import { supabase } from "../../lib/supabase";

export const getCurrentUserId = async () => {
  const {
    data: { user },
    error: authError,
  } = await supabase.auth.getUser();
  if (authError || !user) {
    throw new Error("User not authenticated");
  }
  return user.id;
};